import React from 'react';
export function Sidebar() {
  return <aside className="hidden md:block relative" data-id="element-275">
      <div className="sticky top-6 flex flex-col gap-7" data-id="element-276">
        <div className="bg-brand-gray-100 border border-brand-gray-200 p-5 text-center" data-id="element-277">
          <div className="font-sans text-[0.6rem] tracking-[0.1em] uppercase text-brand-gray-400 mb-3" data-id="element-278">
            Anzeige
          </div>
          <div className="font-serif text-[1.3rem] font-bold text-brand-navy mb-1" data-id="element-279">
            NachTon
          </div>
          <div className="font-sans text-[0.72rem] text-brand-gray-600 leading-[1.5] mb-4" data-id="element-280">
            Die Schlafformel für Männer ab 40. 8 pflanzliche Wirkstoffe.
            Entwickelt in Deutschland.
          </div>
          <a href="https://nachton.de/products/nachton?utm_source=facebook&utm_medium=paid&utm_campaign=nachton_de&utm_content=adv_expert" target="_blank" rel="noopener noreferrer" className="block bg-brand-red text-white font-sans text-[0.75rem] font-medium tracking-[0.05em] uppercase p-2.5 no-underline hover:bg-[#A93226] transition-colors" onClick={() => (window as any).fbq?.('trackCustom', 'ClickNachTon')} data-id="element-281">
            Jetzt entdecken →
          </a>
        </div>

        <div className="border-t-[3px] border-brand-red pt-4" data-id="element-282">
          <h4 className="font-serif text-[0.9rem] font-semibold text-brand-navy mb-3 tracking-[0.01em]" data-id="element-283">
            Das Wichtigste auf einen Blick
          </h4>
          <ul className="pl-3.5 flex flex-col gap-1.5 list-disc font-sans text-[0.78rem] text-brand-gray-600 leading-[1.6]" data-id="element-284">
            <li data-id="element-285">40 % der Männer über 40 betroffen</li>
            <li data-id="element-286">Drei Faktoren wirken zusammen</li>
            <li data-id="element-287">Kürbiskerne allein reichen oft nicht</li>
            <li data-id="element-288">Pygeum adressiert Faktor 3 gezielt</li>
            <li data-id="element-289">Piperin erhöht Bioverfügbarkeit deutlich</li>
          </ul>
        </div>

        <div className="border-t-[3px] border-brand-red pt-4" data-id="element-290">
          <h4 className="font-serif text-[0.9rem] font-semibold text-brand-navy mb-3 tracking-[0.01em]" data-id="element-291">
            Verwandte Artikel
          </h4>

          <div className="py-3 border-b border-brand-gray-200" data-id="element-292">
            <div className="font-sans text-[0.62rem] tracking-[0.1em] uppercase text-brand-red mb-1" data-id="element-293">
              Herz & Kreislauf
            </div>
            <div className="font-serif text-[0.9rem] text-brand-navy leading-[1.35]" data-id="element-294">
              Blutdruck natürlich senken: Was Studien empfehlen
            </div>
          </div>

          <div className="py-3 border-b border-brand-gray-200" data-id="element-295">
            <div className="font-sans text-[0.62rem] tracking-[0.1em] uppercase text-brand-red mb-1" data-id="element-296">
              Vitamine & Mineralstoffe
            </div>
            <div className="font-serif text-[0.9rem] text-brand-navy leading-[1.35]" data-id="element-297">
              Vitamin-D-Mangel im Winter: Wann eine Ergänzung sinnvoll ist
            </div>
          </div>

          <div className="py-3 border-b border-brand-gray-200" data-id="element-298">
            <div className="font-sans text-[0.62rem] tracking-[0.1em] uppercase text-brand-red mb-1" data-id="element-299">
              Psyche & Stress
            </div>
            <div className="font-serif text-[0.9rem] text-brand-navy leading-[1.35]" data-id="element-300">
              Chronischer Stress: Wie er den Körper verändert
            </div>
          </div>

          <div className="py-3" data-id="element-301">
            <div className="font-sans text-[0.62rem] tracking-[0.1em] uppercase text-brand-red mb-1" data-id="element-302">
              Bewegung
            </div>
            <div className="font-serif text-[0.9rem] text-brand-navy leading-[1.35]" data-id="element-303">
              10.000 Schritte am Tag — Mythos oder Medizin?
            </div>
          </div>
        </div>

        <div className="border-t-[3px] border-brand-red pt-4" data-id="element-304">
          <h4 className="font-serif text-[0.9rem] font-semibold text-brand-navy mb-3 tracking-[0.01em]" data-id="element-305">
            Über Vital-Wegweiser
          </h4>
          <p className="font-sans text-[0.78rem] text-brand-gray-600 leading-[1.6]" data-id="element-306">
            Vital-Wegweiser ist Ihr unabhängiger Ratgeber für Gesundheit,
            Naturheilkunde und Wohlbefinden. Unsere Redaktion recherchiert
            sorgfältig und arbeitet mit ausgewiesenen Experten zusammen.
          </p>
        </div>
      </div>
    </aside>;
}